<template>
	<div class="p-4" v-if="channels.length>0">
	<ChannelTable :channels="channels" />
	</div>
</template>

<script setup lang="ts">

import { defineProps,reactive,computed,ref, watch,onMounted,Ref,inject,provide } from 'vue'
import { RouterLink, RouterView,useRoute, useRouter,RouteRecordNormalized,RouteLocationNormalized } from 'vue-router'
import { useChannels } from '@/services/Channels';
import {Channel} from "@/types/Channels";
import MediaThumb from '@/components/MediaThumb.vue'
import MediaList from '@/components/MediaList.vue'
import ChannelTable from '@/components/ChannelTable.vue'
import permissions from "@/services/permissions";
const router = useRouter();
const { checkPermission  } = permissions();
const vhostId = inject<Ref<string> | null>('vhostId', null);
const channels = ref<Channel[]>([]);
const selectedChannel = ref<Channel>();
const parentChannel = ref<Channel>();
const sortOrder = ref('upload desc');
const { getChannels, channelList,getChannelTree } = useChannels();

const fetchChannels = async (vhost:string) => {
	    await getChannelTree(vhost);
     channels.value = [ ...channelList.value];
};

onMounted(() => {
	sortOrder.value='upload DESC';
		if (vhostId && vhostId.value) {
		fetchChannels(vhostId.value);
	}
});
</script>

